import React from 'react';

export default function Logo({ className = "h-8", ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 420 100" 
      fill="none" 
      className={className}
      {...props}
    >
      {/* House & Chart Icon */}
      <g stroke="currentColor" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round">
        {/* House Outline */}
        <path d="M 10 90 L 90 90 L 90 50 L 80 40" />
        <path d="M 70 30 L 50 10 L 10 50 L 10 90" />
        
        {/* Chart Line */}
        <path d="M 18 75 L 30 60 L 40 70 L 52 50 L 62 58 L 88 22" />
      </g>
      
      {/* Arrow Head */}
      <path d="M 75 20 L 96 10 L 88 32 Z" fill="currentColor" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
      
      {/* "site yield" Text */}
      <text 
        x="115" 
        y="68" 
        fontFamily="'Space Grotesk', sans-serif" 
        fontWeight="700" 
        fontSize="60" 
        fill="currentColor"
        letterSpacing="-0.03em"
      >
        site yield
      </text>
    </svg>
  );
}
